import { render } from "./Divider.vue?vue&type=template&id=026b9de8&scoped=true"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=026b9de8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-026b9de8"

export default script